export const buildingTypeConfig = {
  'Building class': [
    'Single dwelling unit',
    'Multi dwelling unit with raiser',
    'Multi dwelling unit without raiser',
    'Business park',
    'Duplex',
    'Standalone warehouse',
    'Shopping mall'
  ],
  'Building type': [
    'Residential',
    'Commercial',
    'Mixed'
  ],
  'Established / New': [
    'Brownfield',
    'Greenfield'
  ]
}
